// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"styles_listContainer__13EsL","listTitle":"styles_listTitle__Oakvh","listItems":"styles_listItems__3Iinl","vertical":"styles_vertical__1qF28"};